import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Payment Confirmation is built. Reached from
// Payroll > Disbursement > Payment Confirmation in the sidebar flyout.
export const DisbursementPaymentConfirmation = () => <NotImplemented title="Payment Confirmation" />;
